export default __webpack_public_path__ + "static/media/device_order.df31b3b6.png";